import queryParams from './queryParams'

if (!Array.prototype.fill) {
    require('core-js/fn/array/fill')
}

if (!console.group || !console.groupEnd) {
    console.group = console.groupEnd = function () {}
}

console.group('Mocks')

const isMobile = queryParams.mobile
window.padl = {
    app: {
        currency: 'EUR',
        landscape: 'NC2-' + (isMobile ? 'mobile-site' : 'mosaic'),
        market: 'US'
    },
    page: {
        pageInfo: {
            breadcrumbUID: 'landing-page::::originalline',
            segmentBusiness: 'B2C',
            language: 'en'
        }
    }
}
// console.info('padl', window.padl)

console.groupEnd('Mocks')
